export default function decodeJwt(token) {
  if (!token || typeof token !== 'string' || token.split('.').length < 2) {
    throw new Error('Invalid JWT');
  }
  const [, payload] = token.split('.');
  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
  const json = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(''),
  );
  return JSON.parse(json);
}
